enum EChannel {
  APPROVAL = "APPROVAL",
  RESET = "RESET",
  MOVE_TO_PAGE = "MOVE_TO_PAGE",
  POP_UP = "POP_UP",
  APPROVAL_PROCESS = "APPROVAL_PROCESS"
}

export default EChannel;
